module.exports = __webpack_public_path__ + "static/img/about_company_banner_en.bddb7f5a.jpg";